import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import MemberPhotoList from 'components/list/MemberPhotoList';

import {t} from 'l10n';

import paths from 'paths';

import 'sass/member/MemberPhotosBlock.scss';
import isMobile from "ismobilejs";

class MemberPhotosBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        let {match, openAddPhotoModal, editMemberPhoto, memberPhotos} = this.props;

        let {list, totalCount} = memberPhotos;

        return (
            <aside className="album-member">
                <div className="content">
                    <div className="heading">
                        <h2>{t('My photos')} <em>{totalCount}</em></h2>
                        <div>
                            {list.length && !isMobile.any ? <Link to={paths.memberAlbum.path} className="list-items">{t('All my photos')}</Link> : null}
                            <a className="add-item" onClick={openAddPhotoModal}>{t('Add a photo')}</a>
                        </div>
                    </div>

                    <MemberPhotoList memberPhotos={list} editFn={editMemberPhoto}/>

                    {(list.length && isMobile.any) ? <Link to={paths.memberAlbum.path} className="get-all-photo">{t('All my photos')}</Link> : <div className="view-all-placehoder"></div>}

                </div>
            </aside>
        )
    }
}

export default MemberPhotosBlock;


// WEBPACK FOOTER //
// ./src/components/member/MemberPhotosBlock.js